import { ReactNode } from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { MIN_COLUMNS_LEN, MAX_COLUMNS_LEN } from '../../common/constants';
const GREEN = '#82B536';
const BLUE = '#1868DB';
const ORANGE = '#FFA900';
const SquiggleBlue = () => (
	<svg
		width="64"
		height="14"
		viewBox="0 0 64 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M63.9947 6.70862C52.9658 9.28601 44.8283 2.69108 33.6895 8.10094C33.1695 5.78395 31.8253 2.88238 29.8131 2.83986C31.4913 2.89301 34.1756 8.94588 31.4786 4.89114C29.8934 1.80359 22.9649 5.57673 28.2744 2.89306C24.6093 3.46168 21.2487 7.21878 18.7715 10.5614C14.6499 15.3229 17.7781 6.10813 14.7979 1.47414C10.5748 -4.96667 -2.24221 11.7837 0.340646 11.7943C1.98505 9.69524 4.19167 8.38792 5.10476 6.0603C21.181 -7.71943 9.58144 17.7834 19.1562 13.5108C34.797 -4.20142 26.8921 11.8315 36.0737 10.7368C41.4254 4.3172 64.1807 14.3823 63.9989 6.70862H63.9947Z"
			fill="#091E42"
			fillOpacity="0.31"
		/>
	</svg>
);
const SquiggleGreen = () => (
	<svg
		width="64"
		height="14"
		viewBox="0 0 64 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M0.447341 5.46691C1.1146 5.92415 1.83039 6.12598 2.56438 6.25373C3.30443 6.38149 4.07481 6.4151 4.96651 6.4151C5.18489 6.3008 5.22736 6.34115 5.16063 6.08563C5.20916 6.02512 5.28801 5.91744 5.23342 5.82331C5.04537 5.22487 5.58525 5.29887 5.79149 5.19129C5.95527 6.19989 7.22914 5.7427 8.41201 4.9022C9.59488 4.06842 10.7777 2.96566 11.1296 2.85807C11.5785 3.66495 12.4156 2.32005 12.9372 2.58901C12.919 2.63608 12.8038 2.88488 12.7917 2.93194C13.0464 3.18073 14.4295 2.33363 15.6124 2.55552C16.1947 2.65638 16.7164 2.96554 16.9105 3.24122C17.1289 3.49674 17.0682 3.59098 16.6132 3.51701L16.7588 3.79937C16.8013 3.90023 16.8438 4.00779 16.8862 4.11538L17.0136 4.42466C17.05 4.53897 17.0864 4.65328 17.1228 4.76759L17.238 5.11052C17.2684 5.23155 17.2987 5.35934 17.329 5.48037C17.3351 5.52072 17.3836 5.64842 17.42 5.76273L17.5413 6.10566C17.6263 6.32755 17.7355 6.54285 17.8628 6.74458C18.3845 7.54473 19.3126 8.05567 20.2832 7.99515C20.7685 7.96825 21.2598 7.82036 21.6966 7.5245C22.0059 7.30261 22.3153 7.08745 22.6247 6.85883C23.0796 6.50246 23.5891 6.24701 24.0805 5.91753C24.3353 5.77633 24.5961 5.65523 24.857 5.51403L25.2512 5.30554L25.6577 5.13744C26.7374 4.63986 27.9081 4.32381 29.1153 4.10192C31.5296 3.66486 34.1076 3.82626 36.4915 4.29694C38.8876 4.78107 41.1017 5.54761 42.9518 6.48898L42.9154 6.36126C42.97 6.41505 43.1702 6.40835 43.1884 6.55628C44.0377 6.38818 46.1365 6.63689 46.1365 6.63689C46.8887 6.68395 47.6469 6.71768 48.4052 6.74458C48.4052 6.74458 49.3333 7.07394 50.4919 7.30256C51.6444 7.55135 53.0335 7.63878 53.8403 7.32275C55.7814 7.61188 57.7772 7.72618 59.7789 7.47739C59.7789 7.47739 60.3916 7.29589 61.0771 7.02693C61.7504 6.7109 62.4904 6.31425 62.7574 5.91753C63.097 5.4603 63.2426 5.01646 63.188 4.68699C63.1334 4.35078 62.8726 4.12209 62.3995 4.10192C61.9324 4.09519 61.2469 4.25658 60.24 4.61968C60.2096 4.58606 60.1186 4.56594 60.0944 4.50542C59.051 5.01645 57.8985 5.00291 56.7823 4.9155C55.6541 4.78774 54.5379 4.54571 53.355 4.44485C53.3672 4.64657 53.2701 4.78784 53.2095 4.68025L53.258 4.43812C51.6202 4.7138 50.7527 3.73207 49.1513 4.2431C49.1513 4.2431 49.3758 3.96746 49.3818 3.96074C46.8705 3.49006 43.9224 2.58906 40.8287 1.80235C37.7351 1.02909 34.4291 0.410515 31.4082 0.659304L31.4386 0.692957L31.4264 0.726446C31.7055 0.854202 32.5062 0.995518 33.2098 1.17707C33.5677 1.25775 33.9014 1.33161 34.144 1.40558C34.3866 1.47282 34.5504 1.51327 34.5504 1.51327C34.0469 1.74861 33.5435 1.85623 33.0339 1.88312C32.5304 1.89657 32.0148 1.8494 31.4932 1.77543C30.4559 1.61406 29.3579 1.42579 28.3146 1.61406L28.2842 1.29805C28.7392 1.23754 29.1638 1.15005 29.5217 1.04919C29.8735 0.955049 30.1586 0.88117 30.3164 0.800482C28.6664 0.67945 26.0519 0.948391 23.6923 2.12509C23.1039 2.42095 22.5215 2.71677 21.9999 3.09331C21.733 3.27486 21.4661 3.443 21.2173 3.63127C20.9747 3.83299 20.7381 4.02807 20.5076 4.22307L20.3378 4.37098C20.2832 4.41804 20.3499 4.371 20.3256 4.3979L20.2832 4.45831C20.2528 4.49865 20.2104 4.5391 20.1619 4.566C20.0709 4.62652 19.9495 4.64658 19.8343 4.62641C19.7736 4.74072 19.8768 4.73396 19.9495 4.76086C20.0284 4.78775 20.083 4.86173 20.1376 5.27862C19.9435 5.29879 19.7372 5.27194 19.5613 5.15763C19.3793 5.05677 19.2702 4.84832 19.1974 4.63987C19.6099 4.41125 19.5371 4.64658 19.622 4.62641C19.6341 4.57262 19.6341 4.49203 19.628 4.3979C19.6402 4.3979 19.6038 4.29702 19.5735 4.20961C19.5431 4.12219 19.5128 4.02795 19.4825 3.92709C19.4218 3.73209 19.3066 3.51022 19.2034 3.27488C19.1003 3.03954 18.9669 2.77738 18.7909 2.51514C18.706 2.38066 18.615 2.2461 18.524 2.09817C18.4149 1.96369 18.2996 1.82257 18.1783 1.68137C17.9538 1.38551 17.6263 1.13675 17.2987 0.867788C16.9408 0.639171 16.5586 0.403739 16.1219 0.269258C15.2666 -0.0333226 14.3446 -0.0535209 13.5014 0.0742355C12.6582 0.208716 11.8878 0.477703 11.1478 0.77356C9.66767 1.37872 8.33922 2.15199 7.08355 2.7975C5.83396 3.44973 4.68141 3.97428 3.71692 4.22307C2.75242 4.47186 2.0063 4.47184 1.44217 4.37771C0.884093 4.27685 0.483737 4.12879 0.295691 4.2431C0.119777 4.33051 0.15011 4.67346 0.677852 5.27862L0.435206 5.44672L0.447341 5.46691Z"
			fill="#091E42"
			fillOpacity="0.31"
		/>
	</svg>
);
const SquiggleOrange = () => (
	<svg
		width="64"
		height="14"
		viewBox="0 0 64 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M0.765963 6.17706C1.14511 6.3765 1.5549 6.3549 1.94172 6.27944C2.723 6.11235 3.4813 5.75126 4.32769 5.38473C4.53833 5.19607 4.57663 5.21768 4.50769 5.02903C4.55365 4.95896 4.63024 4.83499 4.57663 4.77031C4.38897 4.32832 4.9328 4.16113 5.13961 3.99943C5.20472 4.40908 5.54174 4.38758 6.00515 4.19353C6.13919 4.13963 6.18898 4.11272 6.31536 4.09655C6.45324 4.0696 6.59877 4.03717 6.75196 4.00483C7.05069 3.9617 7.38388 3.8971 7.69026 3.94561C8.00048 3.98334 8.29537 4.10722 8.52516 4.3875C8.75878 4.6624 8.92729 5.07205 9.05751 5.46553C9.18772 5.8644 9.28347 6.23631 9.38687 6.53816C9.48262 6.84 9.58219 7.03952 9.63198 7.1581C9.56687 7.3198 9.58219 7.56766 9.72773 7.74014C9.789 7.84795 9.89241 7.89114 9.99581 7.95043C10.1069 7.98816 10.2294 8.00438 10.352 7.99899C10.6048 7.97204 10.846 7.85336 11.0528 7.76173C11.2367 7.65392 11.409 7.58934 11.5392 7.59473C11.5239 7.64863 11.3592 7.90731 11.3401 7.95043C11.4818 8.0205 11.9873 7.73479 12.5618 7.2335C13.1363 6.72683 13.8026 6.03152 14.3809 5.36315C15.549 4.04257 16.4529 2.93757 15.8822 4.12339C16.3227 3.7892 16.7861 3.42817 17.2495 3.01852C17.3644 2.91611 17.4831 2.81366 17.6018 2.71125L17.6822 2.64111L17.7205 2.61426C17.7435 2.59809 17.7703 2.57649 17.7933 2.5711H17.8737C17.8737 2.5711 17.8929 2.58189 17.9159 2.58189L18.0116 2.5711C18.138 2.54954 18.2567 2.5711 18.3831 2.5711C18.8695 2.60344 19.3099 2.73275 19.6201 3.05616C19.9418 3.35801 20.2023 3.87544 20.5201 4.65161C20.681 5.03431 20.8572 5.47639 21.1214 5.95072C21.3818 6.41966 21.7916 6.9532 22.3163 7.21732C22.4465 7.27122 22.5767 7.33592 22.707 7.37365C22.8333 7.4006 22.9636 7.42223 23.0938 7.4384C23.3312 7.4384 23.584 7.43833 23.7946 7.37365C23.9019 7.3467 24.0168 7.32519 24.1202 7.28746L24.4189 7.16889C24.6257 7.09343 24.798 6.98562 24.9857 6.88859C26.4142 6.04774 27.5976 4.89418 28.7696 3.71374L29.501 2.95378L29.8725 2.75428C30.0142 2.67343 30.1406 2.65737 30.2747 2.60347C30.3436 2.57113 30.4011 2.5657 30.4585 2.5657L30.6308 2.54412C30.6883 2.53334 30.7228 2.56031 30.7725 2.56031C30.8185 2.5657 30.8683 2.56034 30.8989 2.59268C31.0483 2.63041 31.1823 2.79205 31.3662 3.06155C31.7262 3.59518 32.136 4.68943 32.9287 5.41171C33.1317 5.5788 33.3309 5.75132 33.553 5.84834C33.6602 5.90224 33.7713 5.96142 33.8785 6.00454L34.2155 6.09087L34.43 6.13929C34.5028 6.15007 34.5717 6.19321 34.6407 6.15548L35.039 6.03691L35.51 5.90216C38.0147 5.1691 40.4773 5.23917 42.5569 5.63265L42.4956 5.54106C42.5607 5.5734 42.7675 5.53025 42.8173 5.64344C43.2309 5.48713 43.9892 5.40086 44.6441 5.34157C45.299 5.27688 45.8505 5.27156 45.8505 5.27156L48.2135 5.10983C48.2135 5.10983 49.2284 5.28231 50.4578 5.37933C51.6872 5.47097 53.131 5.471 53.9544 5.14759C56.011 5.23384 58.0944 5.22839 60.1625 4.81874C60.1625 4.81874 60.3234 4.77564 60.5761 4.70557C60.8251 4.61394 61.1659 4.47381 61.5259 4.31749C61.8859 4.1504 62.2689 4.00488 62.5945 3.79467C62.92 3.57906 63.1996 3.37419 63.3643 3.2017C63.7779 2.77049 64 2.37159 64 2.09131C64 1.81102 63.7702 1.64933 63.2685 1.69784C63.0196 1.72479 62.7017 1.80023 62.3072 1.94576C61.9166 2.09668 61.4264 2.20997 60.8557 2.44174C60.8251 2.42018 60.7255 2.41472 60.7064 2.3716C59.5038 2.89983 58.2514 3.02379 56.9991 3.02918C56.3748 3.04535 55.7391 2.96996 55.1072 2.96457C54.4714 2.94301 53.828 2.88366 53.1769 2.90522C53.2076 3.06153 53.1195 3.18557 53.0429 3.10472L53.0735 2.91061C51.3157 3.23402 50.2433 2.51715 48.6003 3.06155C48.6003 3.06155 48.7956 2.81902 48.7995 2.81363C47.4131 2.73817 45.9041 2.59799 44.3033 2.51175C42.7062 2.40934 41.0211 2.37699 39.3054 2.50096C38.8764 2.54408 38.4475 2.5872 38.0147 2.63032C37.5858 2.68422 37.153 2.78673 36.7241 2.86758L36.0807 2.99694L35.4411 3.19091L34.8053 3.39041L34.5296 3.4766C34.5602 3.4766 34.5143 3.48738 34.5104 3.4766C34.499 3.4766 34.5104 3.47659 34.4836 3.46581L34.3879 3.44963C34.319 3.44963 34.2768 3.39579 34.2194 3.37962C34.1045 3.34728 34.0202 3.2448 33.9168 3.18012C33.7292 2.99686 33.53 2.69506 33.3002 2.28541C33.0666 1.88654 32.8177 1.34216 32.3619 0.824705C32.2662 0.695342 32.1168 0.58746 31.9943 0.474268C31.8679 0.355685 31.7223 0.280229 31.5768 0.210157C31.2819 0.037673 30.9947 0.0323407 30.7151 0C30.7266 0.00539012 30.7419 0.0215921 30.7572 0.0323723L30.7381 0.0592177C30.8415 0.0969485 30.9908 0.150871 31.1708 0.215552C31.347 0.269454 31.5653 0.442043 31.7798 0.592966C32.2087 0.970275 32.5266 1.54696 32.7411 2.0159C32.9632 2.50101 33.1164 2.87837 33.2504 3.14248C33.3845 3.38504 33.4726 3.53594 33.4726 3.52516C33.0475 3.33112 32.6951 2.78135 32.3274 2.19921C32.1321 1.91354 31.9406 1.60089 31.6726 1.36911C31.4198 1.11039 31.1057 0.975576 30.7955 0.905504C30.4891 0.856993 30.1713 0.857014 29.8802 0.927086C29.5662 0.964816 29.3172 1.0834 28.9993 1.19659L28.8653 1.25055C28.8232 1.2775 28.7849 1.3152 28.7427 1.35293L28.5398 1.52545L28.1989 1.8218C27.973 2.02662 27.7547 2.23153 27.5364 2.44174L27.4444 2.22066C27.8198 1.8703 28.153 1.48224 28.4249 1.16422L28.4747 1.105L28.5627 1.00788C28.6202 0.948593 28.6661 0.873226 28.7274 0.835496C28.8423 0.765424 28.9572 0.68991 29.0185 0.646789C29.1564 0.549766 29.2713 0.46354 29.3555 0.393469C29.2406 0.44198 29.1257 0.485106 29.0032 0.533617C28.9304 0.565958 28.8576 0.598262 28.7849 0.630602L28.647 0.695347C28.601 0.727688 28.5627 0.770788 28.5206 0.808519C28.31 1.00256 28.0917 1.20193 27.8619 1.41214C27.4483 1.78945 27.0002 2.18841 26.5291 2.58189C26.0619 2.97537 25.5678 3.38495 25.07 3.72453C24.5797 4.0695 24.0589 4.39288 23.6261 4.51147C23.4231 4.55998 23.2278 4.59775 23.1244 4.56002C23.0172 4.52768 22.9636 4.50069 22.8563 4.37671C22.7529 4.25813 22.6189 4.02097 22.4733 3.71374C22.3278 3.41189 22.1784 3.06159 21.9946 2.68967C21.6461 1.95661 21.1176 1.16432 20.4972 0.727719C19.8767 0.280339 19.2601 0.188602 18.7852 0.215552C18.8082 0.264063 18.9001 0.285698 19.0303 0.291088C19.1606 0.307258 19.3367 0.339557 19.5167 0.382678C19.6967 0.441969 19.8844 0.539007 20.0261 0.66837C20.1678 0.813904 20.2674 0.980961 20.2827 1.16961C19.8346 0.824647 19.3367 0.706106 18.881 0.673766L18.5401 0.662975L18.2146 0.700742C18.1074 0.711523 17.9963 0.716823 17.8967 0.743774C17.7742 0.770725 17.6516 0.792359 17.5329 0.819309C17.5137 0.716897 17.5444 0.646862 17.6056 0.587571C17.6363 0.56062 17.6746 0.533596 17.7167 0.512035C17.7512 0.490475 17.778 0.479647 17.8125 0.463477C17.9427 0.404186 18.0959 0.409618 18.1418 0.371887C18.0959 0.366497 18.0154 0.344921 17.9159 0.355701C17.8661 0.355701 17.8086 0.361101 17.7474 0.366492C17.6554 0.377272 17.5559 0.393479 17.4486 0.404259C17.3912 0.409649 17.3337 0.420456 17.2686 0.431236L17.1729 0.442027C17.1422 0.458197 17.1193 0.490475 17.0925 0.512035C16.9852 0.619838 16.8703 0.733104 16.7478 0.857077C16.6022 0.99722 16.4376 1.15347 16.2614 1.32595C15.5682 1.99972 14.6452 2.90526 13.5767 3.88626C13.0443 4.38215 12.4699 4.86722 11.8801 5.33078C11.7345 5.43858 11.5852 5.54104 11.4358 5.64884C11.2903 5.74047 11.1448 5.83211 10.9954 5.92374L10.7886 6.02073L10.6852 6.07468L10.6469 6.08547C10.5894 6.10703 10.5703 6.10705 10.5435 6.10166C10.486 6.10166 10.4516 6.02619 10.4362 5.95611L10.3213 5.4171C10.2677 5.15299 10.1988 4.83487 10.1069 4.50607C10.015 4.17188 9.88092 3.81077 9.70475 3.45502C9.60134 3.28254 9.50177 3.1047 9.38304 2.94838C9.25666 2.80285 9.1341 2.63574 8.9924 2.52794C8.42942 2.03744 7.83197 1.90813 7.35324 1.90813C6.84771 1.89195 6.43409 1.98891 5.98983 2.10749C5.92089 2.13444 5.8328 2.12913 5.75238 2.18303L5.53408 2.31238L5.25067 2.49556C5.07067 2.61954 4.89833 2.73821 4.73748 2.86219C4.08641 3.3473 3.50428 3.80542 2.96427 4.17195C2.4281 4.53848 1.93023 4.81872 1.54724 4.93731C1.35958 4.9966 1.20256 5.00744 1.11065 4.99666C1.02256 4.99127 0.968943 4.96964 0.903836 4.92652C0.796601 4.85105 0.666387 4.57084 0.589791 4.32289C0.501705 4.08033 0.451918 3.87554 0.386811 3.81085C0.325534 3.74078 0.271917 3.79461 0.222129 3.99943C0.172342 4.20964 0.126384 4.57079 0.19915 5.08825C0.134043 5.0559 0.061277 5.01819 0 4.96968C0.114894 5.51947 0.390641 6.00999 0.773622 6.19864L0.765963 6.17706Z"
			fill="#091E42"
			fillOpacity="0.31"
		/>
	</svg>
);
const Square = ({ color }: { color: string }) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<rect width="12" height="12" fill={color} />
	</svg>
);
const GreyRectangle = () => (
	<svg
		width="17"
		height="4"
		viewBox="0 0 17 4"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path d="M0.199219 0H16.1992V4H0.199219V0Z" fill="#DCDFE4" />
	</svg>
);
const IssueBlock = ({
	color,
	assignedAgent,
}: {
	color: string;
	/**
	 * Optional avatar of the coding agent assigned to this card. When
	 * provided it replaces the default placeholder rectangle.
	 */
	assignedAgent?: ReactNode;
}) => {
	let SquiggleSvg;
	switch (color) {
		case GREEN:
			SquiggleSvg = SquiggleGreen;
			break;
		case ORANGE:
			SquiggleSvg = SquiggleOrange;
			break;
		default:
			SquiggleSvg = SquiggleBlue;
	}
	return (
		<Box xcss={issueBlockStyles}>
			<Flex direction="column" justifyContent="space-between">
				<SquiggleSvg />
				<Flex
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					xcss={issueIconMargin}
				>
					<Square color={color} />
					{/*
					 * Fixed-size, centered slot so the row height/position
					 * stays constant whether the trailing element is the
					 * placeholder rectangle (17x4) or an agent avatar (16x16).
					 * Prevents the row from shifting when an agent
					 * is selected.
					 */}
					<Flex justifyContent="center" alignItems="center" xcss={trailingSlotStyles}>
						{assignedAgent ?? <GreyRectangle />}
					</Flex>
				</Flex>
			</Flex>
		</Box>
	);
};
const ColumnTitle = ({ title }: { title: string }) => (
	<Box xcss={truncatedHeadingStyles}>
		<Box xcss={columnTitleStyles}>{title.toUpperCase()}</Box>
	</Box>
);
const VerticalLine = () => (
	<Box xcss={verticalLineContainerStyles}>
		<Box xcss={verticalLineStyles} />
	</Box>
);
export const BoardColumnsSvg = ({
	columnNames,
	assignedAgents = [],
}: {
	columnNames: string[];
	assignedAgents?: ReactNode[];
}) =>
	columnNames.length >= MIN_COLUMNS_LEN && (
		<Box xcss={containerStyles}>
			<Box xcss={columnStyles}>
				<ColumnTitle title={columnNames[0] as string} />
				<IssueBlock color={BLUE} assignedAgent={assignedAgents[0]} />
				<IssueBlock color={ORANGE} assignedAgent={assignedAgents[1]} />
			</Box>
			<VerticalLine />
			<Box xcss={columnStyles}>
				<ColumnTitle title={columnNames[1] as string} />
				<IssueBlock color={GREEN} assignedAgent={assignedAgents[2]} />
				<IssueBlock color={BLUE} assignedAgent={assignedAgents[3]} />
			</Box>
			<VerticalLine />
			<Box xcss={columnStyles}>
				<ColumnTitle title={columnNames[2] as string} />
				<IssueBlock color={BLUE} />
			</Box>
			{columnNames.length > MIN_COLUMNS_LEN && (
				<>
					<VerticalLine />
					<Box xcss={columnStyles}>
						<ColumnTitle title={columnNames[3] as string} />
						<IssueBlock color={GREEN} />
					</Box>
				</>
			)}
			{columnNames.length === MAX_COLUMNS_LEN && (
				<>
					<VerticalLine />
					<Box xcss={columnStyles}>
						<ColumnTitle title={columnNames[4] as string} />
						<IssueBlock color={GREEN} />
					</Box>
				</>
			)}
		</Box>
	);
const truncatedHeadingStyles = xcss({
	width: '100%',
	maxWidth: '125.333px',
	minWidth: '72px',
	height: '16px',
	marginBlockEnd: 'space.100',
	display: 'flex',
});

const columnTitleStyles = xcss({
	maxWidth: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontSize: '12px',
	color: 'color.text.subtle',
	minHeight: '20px',
	backgroundColor: 'color.background.neutral',
	paddingInlineStart: 'space.050',
	paddingInlineEnd: 'space.050',
	paddingBlockStart: 'space.025',
	borderRadius: 'border.radius.050',
});
const issueBlockStyles = xcss({
	maxWidth: '125.333px',
	minWidth: '72px',
	width: '100%',
	height: '60px',
	backgroundColor: 'color.background.input.hovered',
	padding: 'space.100',
	marginBlockEnd: 'space.100',
	borderRadius: 'border.radius.050',
});
const containerStyles = xcss({
	width: '394px',
	height: '223px',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'stretch',
});
const columnStyles = xcss({
	flex: '1 1 125.333px',
	maxWidth: '125.333px',
	minWidth: '72px',
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
});
const verticalLineContainerStyles = xcss({
	height: '223px',
	width: '9px',
	paddingInlineStart: 'space.050',
	paddingInlineEnd: 'space.050',
	flexShrink: '0',
});
const verticalLineStyles = xcss({
	height: '100%',
	borderInlineStart: `1px solid ${token('color.background.neutral')}`,
});
const issueIconMargin = xcss({ marginBlockStart: 'space.200' });

// Reserves constant space for the trailing icon so swapping the placeholder
// rectangle (17x4) for an agent avatar (16x16) does not change the row's
// height or the colored square's position. Sized to the larger of the two in
// each dimension (17px wide, 16px tall).
const trailingSlotStyles = xcss({
	width: '17px',
	height: '16px',
	flexShrink: '0',
});
